/**
 * Система управления уведомлениями с куки
 */
document.addEventListener('DOMContentLoaded', function() {

    // Функция для работы с куки
    function setCookie(name, value, days) {
        const expires = new Date();
        expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
    }

    function getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    // Функция для скрытия уведомления
    function hideNotification(notificationId) {
        const notification = document.querySelector(`[data-notification-id="${notificationId}"]`);
        if (notification) {
            notification.classList.remove('active');
            // Сохраняем в куки на 1 день
            setCookie(`notification_hidden_${notificationId}`, 'true', 1);
        }
    }

    // Функция для проверки, скрыто ли уведомление
    function isNotificationHidden(notificationId) {
        return getCookie(`notification_hidden_${notificationId}`) === 'true';
    }

    // Инициализация уведомлений
    function initNotifications() {
        const notifications = document.querySelectorAll('.notification[data-notification-id]');

        notifications.forEach(notification => {
            const notificationId = notification.getAttribute('data-notification-id');

            // Проверяем, не скрыто ли уведомление
            if (isNotificationHidden(notificationId)) {
                // Уведомление скрыто, не добавляем класс active
                return;
            }

            // Показываем уведомление, добавляя класс active
            notification.classList.add('active');

            // Добавляем обработчик для кнопки закрытия
            const closeButton = notification.querySelector('.notification-close');
            if (closeButton) {
                closeButton.addEventListener('click', function(e) {
                    e.preventDefault();
                    hideNotification(notificationId);
                });
            }

            // Добавляем обработчики для ссылок
            const links = notification.querySelectorAll('a[data-notification-link]');
            links.forEach(link => {
                link.addEventListener('click', function() {
                    // Скрываем уведомление при переходе по ссылке
                    hideNotification(notificationId);
                });
            });
        });
    }

    // Запускаем инициализацию
    initNotifications();

    // Экспортируем функции для внешнего использования
    window.notificationManager = {
        hideNotification: hideNotification,
        isNotificationHidden: isNotificationHidden,
        setCookie: setCookie,
        getCookie: getCookie
    };
});
